import { createRouter, createWebHistory } from 'vue-router'

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	scrollBehavior(to, from, savedPosition) {
		if (savedPosition) {
			return savedPosition
		}
		if (to.hash) {
			return { el: to.hash, behavior: 'instant' }
		}
		return { left: 0, top: 0, behavior: 'instant' }
	},
	routes: [
		{
			path: '/shop',
			name: 'Shop',
			component: () => import('../views/StoreView.vue')
		},
		{
			path: '/shop/coleccion/:coleccion_id',
			name: 'Colección',
			component: () => import('../views/StoreView.vue')
		},
		{
			path: '/products/:handle',
			name: 'Producto',
			component: () => import('../views/ProductView.vue')
		},
		{
			path: '/experiencias',
			name: 'Experiencias',
			component: () => import('../views/CatasView.vue')
		},
		{
			path: '/tiendas',
			name: 'Tiendas',
			component: () => import('../views/TiendasView.vue')
		},
		{
			path: '/club-chidos',
			name: 'Club Chidos',
			component: () => import('../views/ClubView.vue')
		},
		{
			path: '/',
			name: 'Home',
			component: () => import('../views/HomeView.vue')
		},
		{
			path: '/cava',
			name: 'Cava',
			component: () => import('../views/NuncaSinVinoView.vue')
		},
		{
			path: '/nunca-sin-vino',
			redirect: '/cava'
		},
		{
			path: '/checkout',
			name: 'Checkout',
			component: () => import('../views/CheckoutView.vue')
		},
		{
			path: '/pedido/:pedido_id',
			name: 'Pedido',
			component: () => import('../views/PedidoView.vue')
		},
		{
			path: '/exito',
			name: 'Exito',
			component: () => import('../views/SuccessView.vue')
		},
		{
			path: '/pages/exito',
			name: 'Exito New',
			component: () => import('../views/SuccessView.vue')
		},
		{
			path: '/hcuc',
			name: 'Hecho con Uvas Chidas',
			component: () => import('../views/HCUC.vue')
		},
		{
			path: '/:pathMatch(.*)*',
			name: 'NotFound',
			component: () => import('../views/NotFoundView.vue')
		}
	]
})

export default router
